var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHackeroneLogo = function SvgHackeroneLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4058 10.75C31.9077 10.75 33.1855 11.025 34.2459 11.5582H34.246C35.3065 12.1079 35.8333 12.8005 35.8333 13.6583V72.2641C35.8333 73.0068 35.2801 73.6888 34.1931 74.3097C33.0995 74.9365 31.8421 75.25 30.4059 75.25C28.904 75.25 27.6458 74.9367 26.6247 74.3097C25.5972 73.6828 25.0833 73.0069 25.0833 72.2641V13.6528C25.0833 12.8005 25.5842 12.097 26.5723 11.5582C27.5605 11.0251 28.838 10.75 30.4058 10.75ZM40.9062 47.5562C39.7241 46.3281 38.5249 43.7403 40.1206 42.3273L52.7318 34.8499C53.5745 34.3055 54.6771 34.0417 56.0509 34.0417C57.4297 34.0417 58.5787 34.3055 59.503 34.8497C60.426 35.3833 60.8932 36.0759 60.8932 36.9337V72.2763C60.8932 74.4268 57.1918 75.25 55.5418 75.25C53.7128 75.25 50.1432 73.9065 50.1432 71.6787V59.137V46.5954C49.9791 46.7002 49.8154 46.8056 49.652 46.9108C46.6992 48.8121 43.8682 50.6349 40.9062 47.5562Z",
    fill: "#0A0A0A"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHackeroneLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hackerone-logo.bd5d5277fec0d106e45ac162cb580d42.svg";